import { Type } from '@angular/core';
import { TableCells } from '@adnova/jf-ng-components';

import { TABLE_COLUMNS } from './table-columns.const';

/**
 * Mapping von Spalten-IDs zu Cell-Komponenten für jf-table.
 *
 * Abgeleitet aus {@link TABLE_COLUMNS}.
 */
export const TABLE_CELLS: TableCells = new Map<string, { component: Type<any> }>(
  TABLE_COLUMNS.map(col => [col.id, { component: col.component }])
);
